const { PI } = Math;
/**
 * Given a function that returns a set of rates for a set of units, construct a
 * set of rates for the set of units.
 */
function rates(fn) {
    return fn();
}
/**
 * Given a set of rates for a set of units, construct a converter for the set of
 * units.
 */
function converter(rates) {
    return (value, from, to) => value * (rates[from] / rates[to]);
}
/**
 * @public
 */
export var Converter;
(function (Converter) {
    /**
     * {@link https://drafts.csswg.org/css-values/#lengths}
     */
    Converter.length = converter(rates(() => {
        const px = 1;
        const inch = 96;
        const cm = inch / 2.54;
        const mm = cm / 10;
        const Q = cm / 40;
        const pc = inch / 6;
        const pt = inch / 72;
        return {
            cm,
            mm,
            Q,
            in: inch,
            pc,
            pt,
            px,
        };
    }));
    /**
     * {@link https://drafts.csswg.org/css-values/#angles}
     */
    Converter.angle = converter({
        deg: 1,
        grad: 360 / 400,
        rad: 360 / (2 * PI),
        turn: 360,
    });
    /**
     * {@link https://drafts.csswg.org/css-values/#time}
     */
    Converter.time = converter({
        s: 1,
        ms: 0.001,
    });
    /**
     * {@link https://drafts.csswg.org/css-values/#frequency}
     */
    Converter.frequency = converter({
        hz: 1,
        kHz: 1000,
    });
})(Converter || (Converter = {}));
//# sourceMappingURL=converter.js.map